<div class="fx-column">
  <span class="label" [class.visually-hidden]="visuallyHiddenLabel" *ngIf="label">{{label}}</span>
  <div class="fx-row justify-content-start align-items-center input-wrapper"
    [class]="{'focus':focus,'error':error.value}" [class.active]="value.start || value.end">
    <input [type]="type" [placeholder]="placeholder" [(ngModel)]="selection" (ngModelChange)="valueUpdate.next($event)"
      (focus)="focus = true;picker.open();" (blur)="focus = false;picker.close();" [disabled]="disabled" #input
      class="fx-flex" style="background-color: transparent !important;"
      [style]="(value.start || value.end) ? 'color: #8847E3 !important;' : null" />
    <mat-date-range-input [rangePicker]=" picker" [disabled]="disabled" (focus)="focus = true" (blur)="focus = false"
      style="width: 0 !important;height:0 !important;background-color: transparent !important;" separator="">
      <input matStartDate style="width: 0 !important;height:0 !important;background-color: transparent !important;"
        [value]="value.start" (dateChange)="onStartDateChange($event)">
      <input matEndDate style="width: 0 !important;height:0 !important;background-color: transparent !important;"
        [value]="value.end" (dateChange)="onEndDateChange($event)">
    </mat-date-range-input>
    <mat-icon class="suffix mb-5 clickable" [class.light]="disabled" [class.main]="value.start || value.end"
      [class.focus]="focus" fontSet="material-icons-outlined" (click)="clear()"
      *ngIf="this.clearable && (value.start || value.end)">
      clear
    </mat-icon>
    <mat-icon class="suffix mb-5 clickable" [class.light]="disabled" [class.main]="value.start || value.end"
      [class.focus]="focus" fontSet="material-icons-outlined" (click)="picker.open()">event
    </mat-icon>
    <mat-date-range-picker #picker (closed)="input.blur()" [xPosition]="'end'"></mat-date-range-picker>
  </div>
</div>